import qwest from 'qwest';

let csvApi = {
  upload(csv, format = 'cust-only') {
    let formData = new FormData();

    formData.append('file', csv);
    formData.append('format', format);

    return qwest.post('/UploadCSV', formData, {
      responseType: 'json',
      dataType: 'formdata',
      timeout: 600000, // 10 mins
    }).then(this._handleResponse);
  },
  uploadContacts(csv, flag) {
    let formData = new FormData();

    formData.append('file', csv);
    formData.append('saveChanges', flag);
    return qwest.post('/UploadCSV/ContactEmails', formData, {
      responseType: 'json',
      dataType: 'formdata',
      timeout: 600000, // 10 mins
    }).then(this._handleResponse);
  },

  export({
    branchIds, poolTypes, allAnalyses, analysisCreatedStart, analysisCreatedEnd,
  }) {
    return qwest.post('/Export', {
      branchIds,
      poolTypes,
      allAnalyses,
      analysisCreatedStart,
      analysisCreatedEnd,
    }).then(this._handleResponse);
  },

  exportHistory() {
    return qwest.get('/Export/History').then(this._handleResponse);
  },

  _handleResponse(xhr, response) {
    if (response.success) {
      return response.data;
    } else {
      throw response;
    }
  },
};

export default csvApi;
